var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var ensureExistence = (scopeName, key) => {
	var scope = __webpack_require__.S[scopeName];
	if(!scope || !__webpack_require__.o(scope, key)) throw new Error("Shared module " + key + " doesn't exist in shared scope " + scopeName);
	return scope;
};
var findVersion = (scope, key) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key) => {
	var versions = scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getSingleton = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	return get(scope[key][version]);
};
var getSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) typeof console !== "undefined" && console.warn && console.warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var getStrictSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) throw new Error(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var findValidVersion = (scope, key, requiredVersion) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ") of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var getValidVersion = (scope, scopeName, key, requiredVersion) => {
	var entry = findValidVersion(scope, key, requiredVersion);
	if(entry) return get(entry);
	throw new Error(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var warnInvalidVersion = (scope, scopeName, key, requiredVersion) => {
	typeof console !== "undefined" && console.warn && console.warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var init = (fn) => (function(scopeName, a, b, c) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then) return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], a, b, c));
	return fn(scopeName, __webpack_require__.S[scopeName], a, b, c);
});

var load = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return get(findVersion(scope, key));
});
var loadFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	return scope && __webpack_require__.o(scope, key) ? get(findVersion(scope, key)) : fallback();
});
var loadVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getValidVersion(scope, scopeName, key, version);
});
var loadStrictSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var loadVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingletonFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	var entry = scope && __webpack_require__.o(scope, key) && findValidVersion(scope, key, version);
	return entry ? get(entry) : fallback();
});
var loadStrictSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var installedModules = {};
var moduleToHandlerMapping = {
	4096: () => (loadSingletonVersionCheckFallback("default", "@angular/core", [2,13,3,2], () => (__webpack_require__.e(5084).then(() => (() => (__webpack_require__(5084))))))),
	6343: () => (loadSingletonVersionCheckFallback("default", "@angular/common", [2,13,3,2], () => (__webpack_require__.e(674).then(() => (() => (__webpack_require__(674))))))),
	2416: () => (loadSingletonVersionCheckFallback("default", "@angular/forms", [2,13,3,2], () => (__webpack_require__.e(4588).then(() => (() => (__webpack_require__(7233))))))),
	3324: () => (loadSingletonVersionCheckFallback("default", "@angular/material/form-field", [1,13,3,2], () => (__webpack_require__.e(7708).then(() => (() => (__webpack_require__(6540))))))),
	9290: () => (loadSingletonVersionCheckFallback("default", "@angular/material/core", [1,13,3,2], () => (__webpack_require__.e(9835).then(() => (() => (__webpack_require__(6911))))))),
	730: () => (loadSingletonVersionCheckFallback("default", "@angular/material/button", [1,13,3,2], () => (__webpack_require__.e(6246).then(() => (() => (__webpack_require__(7350))))))),
	1927: () => (loadSingletonVersionCheckFallback("default", "@angular/material/input", [1,13,3,2], () => (__webpack_require__.e(2872).then(() => (() => (__webpack_require__(9325))))))),
	8550: () => (loadSingletonVersionCheckFallback("default", "@angular/common/http", [2,13,3,2], () => (__webpack_require__.e(5527).then(() => (() => (__webpack_require__(4527))))))),
	474: () => (loadSingletonVersionCheckFallback("default", "@angular/material/divider", [1,13,3,2], () => (__webpack_require__.e(281).then(() => (() => (__webpack_require__(7808))))))),
	1300: () => (loadSingletonVersionCheckFallback("default", "@angular/material/select", [1,13,3,2], () => (__webpack_require__.e(1056).then(() => (() => (__webpack_require__(196))))))),
	8108: () => (loadSingletonVersionCheckFallback("default", "@angular/material/tooltip", [1,13,3,2], () => (__webpack_require__.e(8992).then(() => (() => (__webpack_require__(1136))))))),
	422: () => (loadSingletonVersionCheckFallback("default", "@angular/material/icon", [1,13,3,2], () => (__webpack_require__.e(4557).then(() => (() => (__webpack_require__(7758))))))),
	7729: () => (loadStrictSingletonVersionCheckFallback("default", "amazon-cognito-identity-js", [1,5,2,8], () => (__webpack_require__.e(1168).then(() => (() => (__webpack_require__(1694)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"92": [
		2416,
		4096,
		6343,
		9290
	],
	"196": [
		2416,
		3324,
		4096,
		6343,
		9290
	],
	"705": [
		4096,
		6343,
		9290
	],
	"1056": [
		2416
	],
	"1136": [
		4096,
		6343,
		9290
	],
	"1160": [
		4096
	],
	"1652": [
		422,
		730,
		4096,
		6343,
		9290
	],
	"2167": [
		2416,
		3324,
		4096,
		6343,
		9290
	],
	"2209": [
		4096,
		6343,
		9290
	],
	"2399": [
		4096
	],
	"2507": [
		730,
		4096,
		6343,
		9290
	],
	"2586": [
		4096,
		6343,
		9290
	],
	"2760": [
		4096,
		6343,
		9290
	],
	"3142": [
		4096,
		6343,
		9290
	],
	"3978": [
		4096,
		6343,
		9290
	],
	"4212": [
		2416,
		4096,
		6343,
		9290
	],
	"4453": [
		4096,
		6343,
		9290
	],
	"4527": [
		4096,
		6343
	],
	"4557": [
		8550
	],
	"4652": [
		730,
		1300,
		3324,
		4096,
		6343,
		8108,
		9290
	],
	"5106": [
		730,
		1927,
		2416,
		3324,
		4096,
		6343,
		9290
	],
	"5226": [
		474,
		2416,
		4096,
		6343,
		9290
	],
	"5338": [
		7729
	],
	"5626": [
		2416,
		4096,
		6343,
		9290
	],
	"5638": [
		4096,
		6343
	],
	"5853": [
		4096,
		6343,
		9290
	],
	"6030": [
		4096,
		6343,
		9290
	],
	"6540": [
		4096,
		6343,
		9290
	],
	"6911": [
		4096,
		6343
	],
	"7233": [
		4096,
		6343
	],
	"7276": [
		4096,
		6343,
		9290
	],
	"7350": [
		4096,
		6343,
		9290
	],
	"7758": [
		4096,
		6343,
		8550,
		9290
	],
	"7808": [
		4096,
		9290
	],
	"7833": [
		4096,
		6343,
		9290
	],
	"9325": [
		2416,
		3324,
		4096,
		6343,
		9290
	],
	"9520": [
		2416,
		3324,
		4096,
		6343,
		9290
	],
	"9528": [
		2416,
		4096,
		6343,
		9290
	],
	"9574": [
		2416,
		4096,
		6343,
		9290
	],
	"9763": [
		4096,
		6343,
		9290
	],
	"9835": [
		6343
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
		});
	}
}